export default __webpack_public_path__ + "static/media/icon-trash.c2299735.svg";